import { http } from "api/http";
import { QueryFunctionContext } from "react-query";

interface McaFilingParams {
    cin: string;
}

interface McaFilingResponse {
    success: boolean;
    data: any;
    message?: string;
}

const getMcaFilingStatus = async (
    context: QueryFunctionContext<[string, McaFilingParams]>
): Promise<McaFilingResponse> => {
    const [, params] = context.queryKey;

    const response = await http.get("/mca/filing-status", {
        params: {
            cin: params.cin,
        },
    });

    return response.data;
};
const getMcaMasterData = async (
    context: QueryFunctionContext<[string, McaFilingParams]>
): Promise<any> => {
    const [, params] = context.queryKey;

    const response = await http.post("/mca/master-data", {
        cin: params.cin,
    });

    return response.data;
};

interface McaCompanyParams {
    companyName: string;
}

interface McaCompanyResponse {
    success: boolean;
    data: any;
}

const getMcaCompanyDetails = async (
    params: McaCompanyParams
): Promise<any> => {
    const response = await http.post("/mca/company-details", {
        company_name: params.companyName,
    });

    return response.data;
};

const getMcaClients = ({ queryKey }: any) => {
  return http.get("/mca/clients", { params: { ...queryKey[1] } });
};



export { getMcaFilingStatus, getMcaCompanyDetails, getMcaMasterData, getMcaClients };
